import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useService from "../../../Hooks/useService";
import ContentLayout from "../../../Layout/ContentLayout";
import ServiceResult, { Loaders, } from "../../../UI/ServiceResult/ServiceResult";
import CustomCard from "../../../UI/CustomCard/CustomCard";
import InfoItems from "../../../UI/InfoItems/InfoItems";
import BooleanDisplay from "../../../UI/BooleanDisplay/BooleanDisplay";
import { getSuccessScoringReasonIndexPath } from "./SuccessScoringReasonRoutes";
import AuditData from "../../../UI/AuditData/auditData";
import SuccessScoringReasonService from "../../../../Services/SuccessScoringReason.service";
const SuccessScoringReasonDetail = () => {
    const params = useParams();
    const successScoringReasonId = parseInt(params.id, 10);
    const [loadSuccessScoringReasonState, loadSuccessScoringReason] = useService(SuccessScoringReasonService.get);
    useEffect(() => {
        if (successScoringReasonId) {
            loadSuccessScoringReason(successScoringReasonId);
        }
    }, [loadSuccessScoringReason, successScoringReasonId]);
    return (_jsx(ServiceResult, { loader: Loaders.overlay(), state: loadSuccessScoringReasonState, children: (successScoringReason) => (_jsx(ContentLayout, { paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: _jsxs(_Fragment, { children: [_jsxs("h1", { className: "pb-2", children: [_jsx(Link, { to: getSuccessScoringReasonIndexPath(), className: "text-decoration-none pr-2", title: "Back to success scoring reasons", children: _jsx("span", { className: "fal fa-arrow-circle-left" }) }), successScoringReason.srcSystemId] }), _jsx(CustomCard, { title: "Details", className: "mt-3", children: _jsx("div", { className: "card-body", children: _jsx(InfoItems, { numColumnsLg: 1, numColumnsMd: 1, numColumnsSmAndSmaller: 1, items: [
                                    {
                                        label: "Description",
                                        value: successScoringReason.description,
                                    },
                                    {
                                        label: "Source Description",
                                        value: successScoringReason.srcDescription,
                                    },
                                    {
                                        label: "Active",
                                        value: (_jsx(BooleanDisplay, { val: successScoringReason.active })),
                                    },
                                ] }) }) }), _jsx(AuditData, { createdBy: successScoringReason.createdBy, createdDate: successScoringReason.createdDate, modifiedBy: successScoringReason.modifiedBy, modifiedDate: successScoringReason.modifiedDate })] }) })) }));
};
export default SuccessScoringReasonDetail;
